import { createContext } from 'react';
import { type PaletteMode } from '@mui/material';
import { type Language } from '../types/language';
import { type EnergySubmissionType } from '../controller/energyLabelForm';

export interface EnergyLabelSession {
  leadId: string;
  submissionId: string;
  phone: string;
}

/** The building the certificate is about, as shown in the form header. */
export interface EnergyLabelBuilding {
  address: string;
  gnr?: string;
  bnr?: string;
  buildingNumber?: string;
  buildingType?: string;
  buildYear?: string;
  footprint?: string;
  usableArea?: string;
}

export interface EnergyLabelContextType {
  language: Language;
  languageCode: string;
  setLanguageCode: (code: string) => void;
  mode: PaletteMode;
  setMode: (mode: PaletteMode) => void;
  session: EnergyLabelSession | null;
  building: EnergyLabelBuilding | null;
  isLoggedIn: boolean;
  /** the lead the form link carries, what the SMS login is for */
  leadId: string | null;
  login: (session: EnergyLabelSession) => void;
  logout: () => Promise<void>;
  submissionId?: string;
  submission: EnergySubmissionType | null;
  reload: () => Promise<void>;
  submit: () => Promise<void>;
  /** message from the last failed save, cleared by the next successful one */
  saveError?: string;
  savedAt: Date | null;
  reportSave: (error?: string) => void;
  /** saves what the current step still holds, awaited before submit */
  flushSave: () => Promise<void>;
  registerFlushSave: (flush: (() => Promise<void>) | null) => void;
}

const EnergyLabelContext = createContext<EnergyLabelContextType | undefined>(
  undefined
);

export const EnergyLabelProvider = EnergyLabelContext.Provider;

export default EnergyLabelContext;
